import { initializeApp } from 'firebase/app';
const firebaseConfig = {
    apiKey: "AIzaSyCupCaYRHJUAYnBad6joHfwss3FnEDLAtc",
    authDomain: "hackduke21-a252f.firebaseapp.com",
    projectId: "hackduke21-a252f",
    storageBucket: "hackduke21-a252f.appspot.com",
    messagingSenderId: "660111393131",
    appId: "1:660111393131:web:94723d249c572c870dcc2e",
    measurementId: "G-TGX71QVFKH"
  };
const firebaseApp = initializeApp(firebaseConfig);
export default firebaseApp;